import { VendorFormFragment } from 'generated/resources/graphql'

export const getVendorAttributes = (data: VendorFormFragment) => {
  return {
    merchantName: data.expense?.merchantName,
    merchantTin: data.expense?.merchantTin,
  }
}
